import { render, staticRenderFns } from "./MiniEmployeeCard.vue?vue&type=template&id=28cf721c&scoped=true"
import script from "./MiniEmployeeCard.vue?vue&type=script&lang=js"
export * from "./MiniEmployeeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf721c",
  null
  
)

export default component.exports